//@flow
export default {
  getWeightOz(lbs:?number):?string {
    if (!lbs) return undefined;
    let size = (lbs * 16).toFixed(1);
    if (size.slice(-1) === '0') size = size.slice(0,-2);
    return size;
  },

  convertNumberNoRounding(num:number|string):string {
    if (!num) return '0.00';

    let convertedNumber = num.toString();
    if (convertedNumber.indexOf('.') === -1) return convertedNumber + '.00';
    if (convertedNumber.length < 4) convertedNumber += '0';
    return convertedNumber.slice(0, (convertedNumber.indexOf("."))+3);
  },

  toFixed(num:?number|string):string {
    if (typeof num === 'string') return num;
    if (!num) num = 0;
    return num.toFixed(2);
  },

  roundCentsToDollar(num:number):string {
    let priceAsNumber = num.toFixed(2);
    const cents = Number( parseInt(priceAsNumber.toString().split(".")[1], 10) );
    if(cents > 98) {
      priceAsNumber = Math.round( Number(priceAsNumber) );
    }
    return String(priceAsNumber);
  },

  toString(num:?number|string):string {
    return (num && num.toString()) || '';
  },
};
